import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
})
export class HeaderLogoComponent {
  @Input() path = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() internal = true;
}
